import { Alert } from "react-bootstrap";
import WidgetBase from "../common/widgetBase";
import Message from "./../common/message";
import { Converter } from "../../workspace/converter";

export default class MessageNode extends WidgetBase {
  renderBody() {
    // Find messages data
    const [ messagesValue, warning ] = this.loadObjectValue(
      this.props.data.component, "messages", "messages");
    let messages = messagesValue ? messagesValue["messages"] : null;

    // Trim messages to max length
    if ( messages ) {
      const maxMessages = Converter.getComponentPortValueData(this.props.data.component, "max_messages");
      if ( maxMessages ) {
        messages = messages.slice(0, maxMessages);
      }
    }

    // Find out what is the default content view
    const contentView = Converter.getComponentPortValueData(this.props.data.component, "content_view");

    // Render messages content
    return (
      <>
        {warning &&
          <Alert variant="info">
            {warning}
          </Alert>
        }
        {(!warning && !messages) &&
          <Alert variant="warning">
            Messages object contains no value.
          </Alert>
        }
        {(!warning && messages) &&
          <>
            {messages.map((messageValue, index) => (
              <Message
                key={index}
                value={messageValue}
                contentView={contentView}
              />
            ))}
          </>
        }
      </>
    );
  }
}
